import * as z from "zod/v4";

export const updateAddressSelfServe: {
  name: "updateAddressSelfServe";
  input: z.ZodObject<{
    orderIdOrOrderNoOrConfirmationNo: z.ZodString;
    customerEmail: z.ZodString;
    shippingAddress: z.ZodObject<{
      firstName: z.ZodOptional<z.ZodNullable<z.ZodString>>;
      lastName: z.ZodOptional<z.ZodNullable<z.ZodString>>;
      address1: z.ZodString;
      address2: z.ZodOptional<z.ZodNullable<z.ZodString>>;
      city: z.ZodOptional<z.ZodNullable<z.ZodString>>;
      provinceCode: z.ZodOptional<z.ZodNullable<z.ZodString>>;
      zip: z.ZodOptional<z.ZodNullable<z.ZodString>>;
      countryCode: z.ZodOptional<z.ZodNullable<z.ZodString>>;
    }>;
  }>;
  output: z.ZodObject<{
    success: z.ZodBoolean;
    orderNumber: z.ZodString;
    error: z.ZodOptional<z.ZodString>;
    updatedShippingAddress: z.ZodOptional<
      z.ZodObject<{
        firstName: z.ZodOptional<z.ZodNullable<z.ZodString>>;
        lastName: z.ZodOptional<z.ZodNullable<z.ZodString>>;
        address1: z.ZodString;
        address2: z.ZodOptional<z.ZodNullable<z.ZodString>>;
        city: z.ZodOptional<z.ZodNullable<z.ZodString>>;
        provinceCode: z.ZodOptional<z.ZodNullable<z.ZodString>>;
        zip: z.ZodOptional<z.ZodNullable<z.ZodString>>;
        countryCode: z.ZodOptional<z.ZodNullable<z.ZodString>>;
      }>
    >;
    validationDetails: z.ZodOptional<
      z.ZodObject<{
        validated: z.ZodBoolean;
        possibleAddresses: z.ZodOptional<
          z.ZodArray<
            z.ZodObject<{
              firstName: z.ZodOptional<z.ZodNullable<z.ZodString>>;
              lastName: z.ZodOptional<z.ZodNullable<z.ZodString>>;
              address1: z.ZodString;
              address2: z.ZodOptional<z.ZodNullable<z.ZodString>>;
              city: z.ZodOptional<z.ZodNullable<z.ZodString>>;
              provinceCode: z.ZodOptional<z.ZodNullable<z.ZodString>>;
              zip: z.ZodOptional<z.ZodNullable<z.ZodString>>;
              countryCode: z.ZodOptional<z.ZodNullable<z.ZodString>>;
            }>
          >
        >;
      }>
    >;
  }>;
} = {
  name: "updateAddressSelfServe" as const,
  input: z.object({
    orderIdOrOrderNoOrConfirmationNo: z
      .string()
      .describe("The order number, ID, or confirmation number"),
    customerEmail: z
      .string()
      .describe("Customer's email address for verification"),
    shippingAddress: z.object({
      firstName: z.string().nullable().optional(),
      lastName: z.string().nullable().optional(),
      address1: z.string().describe("Street address line 1"),
      address2: z.string().nullable().optional(),
      city: z.string().nullable().optional(),
      provinceCode: z.string().nullable().optional(),
      zip: z.string().nullable().optional(),
      countryCode: z.string().nullable().optional(),
    }),
  }),
  output: z.object({
    success: z.boolean(),
    orderNumber: z.string(),
    error: z.string().optional(),
    updatedShippingAddress: z
      .object({
        firstName: z.string().nullable().optional(),
        lastName: z.string().nullable().optional(),
        address1: z.string(),
        address2: z.string().nullable().optional(),
        city: z.string().nullable().optional(),
        provinceCode: z.string().nullable().optional(),
        zip: z.string().nullable().optional(),
        countryCode: z.string().nullable().optional(),
      })
      .optional(),
    validationDetails: z
      .object({
        validated: z.boolean(),
        possibleAddresses: z
          .array(
            z.object({
              firstName: z.string().nullable().optional(),
              lastName: z.string().nullable().optional(),
              address1: z.string(),
              address2: z.string().nullable().optional(),
              city: z.string().nullable().optional(),
              provinceCode: z.string().nullable().optional(),
              zip: z.string().nullable().optional(),
              countryCode: z.string().nullable().optional(),
            }),
          )
          .optional(),
      })
      .optional(),
  }),
};
